// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Russo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
h1 {
  margin: 0 auto;
  padding: 0;
  text-align: center;
}

ul {
  padding: 0 ; 
  margin: 0 ;
}

.bigboldyellow{
  font-family: 'Russo';
  letter-spacing: 0.5px;
  transition: padding 0.2s ease;
  color: #ffffff; /* or #fecb00 for yellow */
  font-size: 3rem;
  margin: 0 auto;
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  color: #fecb00;
}

.bigboldwhite{
  font-family: 'Russo';
  letter-spacing: 0.5px;
  transition: padding 0.2s ease;
  color: #ffffff; /* or #fecb00 for yellow */
  font-size: 3rem;
  margin: 0 auto;
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  color: #ffffff;
}

.medboldyellow{
  font-family: 'Russo';
  letter-spacing: 0.5px;
  transition: padding 0.2s ease;
  color: #ffffff; /* or #fecb00 for yellow */
  font-size: 1.5rem;
  margin: 0 auto;
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  color: #fecb00;
}

.medboldwhite{
  font-family: 'Russo';
  letter-spacing: 0.5px;
  transition: padding 0.2s ease;
  color: #ffffff; /* or #fecb00 for yellow */
  font-size: 1.5rem;
  margin: 0 auto;
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  color: #ffffff;
}

.bignormaltext{
  font-family: 'Roboto';
  transition: padding 0.2s ease;
  color: #ffffff;
  font-size: 24px;
}

.bigboldyellow,
.bigboldwhite {
  font-size: 3rem; /* Default for desktop */
}

@media screen and (max-width: 768px) {
  .bigboldyellow,
  .bigboldwhite {
    font-size: 2rem; /* Smaller font size for mobile */
  }
}


.normalText {
  letter-spacing: 1px;
  color: #ffffff;
  font-family: 'Roboto';

}


body {
    /* width: 100vh;
    height: 100vh; */
    /* background: #cce8ff; */
    animation: gradient 15s ease infinite;
    word-wrap: break-word;
  white-space: normal;
  text-align: center;
  background-color: #008cff;
}
a {
  text-decoration: none;
}
@font-face {
  font-family: 'Russo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* Add other font properties if needed, like font-weight and font-style */
}
/* 
@keyframes gradient {
    0% {
      background-color: #ee5252f2;
    }
    50% {
      background-color: #23a6d5;
    }  
    100% {
        background-color: #ee5252f2;
    }
} */

.box{
    display: flex;
    justify-content: center;
    align-items: center;
}

h1 {
    text-align: center;
}

#myCarousel{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sidebar {
    background-color: #f0f0f0;
    width: 200px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    padding: 20px;
  }
  
  .content {
    margin-left: 200px;
    padding: 20px;
  }

  /* The side navigation menu */
.sidenav {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #111; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

/* The navigation menu links */
.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s;
  padding: 20px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

a{
  color: white;
}

.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Set the container height to 100% of the viewport height */
  background: black;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

ul {
  flex-grow: 1; /* Make the UL element fill the remaining height */
  /* Add any other styles for your UL element */
  padding-left: 0;
  padding-right: 0;
}

.col-9-full-width {
  width: 100%;
}

.col-9{
  width: 75%;
}

.images{
  padding: 20px;
  border-radius: 30px ;
}


button{
  border-radius: 80px !important;
  border: double 2px #ffffff;
  background-image: linear-gradient(#fecb00, #fecb00);
  /* background-clip: padding-box, border-box; */
  cursor: pointer;
  padding: 10px 15px; /* Initial padding */
  align-items: center;
  justify-content: center;
  color: #005293;
  transition: padding 0.2s ease; /* Smooth transition for padding */
  font-weight: 900;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
  text-shadow: 0px 0px 0px #008cff;
  font-size: 24px;
}

button:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
  background-image: linear-gradient(#005293, #005293);
  color: #fecb00;
  border: double 2px #fecb00 ;
  /* border: 5px solid var(--accent-color); */
}

.nonScrollable {
  height: 100vh; /* Set the height to 100% of the viewport height */
  overflow: hidden; /* Hide any content that exceeds the container height */
  /* background-color: blue; */
  flex-shrink: 0;
}

.scrollable {
  height: 100vh; /* Set the height to 100% of the viewport height */
  overflow-y: scroll; /* Add a vertical scrollbar when content exceeds the container height */
  /* background-color: #cce8ff; */
  background-color: #193551;
}

.scrollableContent {
  /* height: 100%; Ensure the scrollable content takes up the full height of the container */
  /* display: flex; */
/* justify-content: center;
align-items: center; */
}

/* When the sidebar collapses */
.sidebar-collapsed body {
  /* Adjust the scrollbar width to 100% */
  scrollbar-width: auto;  /* For Firefox */
  scrollbar-color: initial;  /* For Chrome, Edge, and Safari */
}

.showSidebar{
  display: block;
}

.hideSidebar{
  display: none;
} 

.tier-list {
  display: flex;
  justify-content: space-around;
  gap: 20px;
}

.tier {
  border: 1px solid #ccc;
  padding: 20px;
  max-width: 300px;
  text-align: center;
}

@media (max-width: 768px) {
  .row {
    flex-direction: row; /* Ensure it remains a row */
  }

  .col-auto {
    flex: 0 0 auto; /* Prevent columns from stretching */
  }

  .col {
    flex: 1; /* Allow this column to fill remaining space */
  }

  

  button {
    margin: 0; /* Ensure proper alignment for the button */
    padding: 25px 35px; /* Initial padding */
  }
}
.contained {
  background: #66baff;
  padding: 10px 15px; /* Adjust padding to control spacing */
  margin: 10px;
  border: 3px solid black;
  border-radius: 20px;
  text-align: center; /* Centers text */
  box-sizing: border-box; /* Ensures padding is included in the dimensions */
}

.contained p {
  margin: 0; /* Removes default margin on the <p> tag */
  line-height: 1.5; /* Adjust line height for better spacing */
}

@media (max-width: 650px) {
  .contained {
    background-color: #b3ddff;
    border-radius: 10px;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc,EAAE,0BAA0B;EAC1C,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc,EAAE,0BAA0B;EAC1C,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc,EAAE,0BAA0B;EAC1C,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc,EAAE,0BAA0B;EAC1C,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE;;IAEE,eAAe,EAAE,iCAAiC;EACpD;AACF;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;;AAEvB;;;AAGA;IACI;oBACgB;IAChB,yBAAyB;IACzB,qCAAqC;IACrC,qBAAqB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,+DAAwC;EACxC,yEAAyE;AAC3E;AACA;;;;;;;;;;;GAWG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA,6BAA6B;AAC/B;EACE,YAAY,EAAE,qBAAqB;EACnC,QAAQ,EAAE,0CAA0C;EACpD,eAAe,EAAE,kBAAkB;EACnC,UAAU,EAAE,gBAAgB;EAC5B,MAAM,EAAE,oBAAoB;EAC5B,OAAO;EACP,sBAAsB,EAAE,SAAS;EACjC,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB,EAAE,oCAAoC;EACvD,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,sHAAsH;AACtH;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA,gIAAgI;AAChI;EACE,UAAU,iBAAiB,CAAC;EAC5B,YAAY,eAAe,CAAC;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,4DAA4D;EAC3E,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY,EAAE,kDAAkD;EAChE,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;;AAGA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,mDAAmD;EACnD,8CAA8C;EAC9C,eAAe;EACf,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B,EAAE,kCAAkC;EACjE,gBAAgB;EAChB,uCAAuC,EAAE,8BAA8B;EACvE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uCAAuC,EAAE,8BAA8B;EACvE,mDAAmD;EACnD,cAAc;EACd,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa,EAAE,kDAAkD;EACjE,gBAAgB,EAAE,uDAAuD;EACzE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,kDAAkD;EACjE,kBAAkB,EAAE,uEAAuE;EAC3F,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,0FAA0F;EAC1F,mBAAmB;AACrB;sBACsB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;EACvC,qBAAqB,GAAG,gBAAgB;EACxC,wBAAwB,GAAG,iCAAiC;AAC9D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB,EAAE,4BAA4B;EACnD;;EAEA;IACE,cAAc,EAAE,oCAAoC;EACtD;;EAEA;IACE,OAAO,EAAE,8CAA8C;EACzD;;;;EAIA;IACE,SAAS,EAAE,2CAA2C;IACtD,kBAAkB,EAAE,oBAAoB;EAC1C;AACF;AACA;EACE,mBAAmB;EACnB,kBAAkB,EAAE,sCAAsC;EAC1D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,iBAAiB;EACrC,sBAAsB,EAAE,kDAAkD;AAC5E;;AAEA;EACE,SAAS,EAAE,0CAA0C;EACrD,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\nh1 {\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n}\n\nul {\n  padding: 0 ; \n  margin: 0 ;\n}\n\n.bigboldyellow{\n  font-family: 'Russo';\n  letter-spacing: 0.5px;\n  transition: padding 0.2s ease;\n  color: #ffffff; /* or #fecb00 for yellow */\n  font-size: 3rem;\n  margin: 0 auto;\n  text-align: center;\n  word-wrap: break-word;\n  white-space: normal;\n  color: #fecb00;\n}\n\n.bigboldwhite{\n  font-family: 'Russo';\n  letter-spacing: 0.5px;\n  transition: padding 0.2s ease;\n  color: #ffffff; /* or #fecb00 for yellow */\n  font-size: 3rem;\n  margin: 0 auto;\n  text-align: center;\n  word-wrap: break-word;\n  white-space: normal;\n  color: #ffffff;\n}\n\n.medboldyellow{\n  font-family: 'Russo';\n  letter-spacing: 0.5px;\n  transition: padding 0.2s ease;\n  color: #ffffff; /* or #fecb00 for yellow */\n  font-size: 1.5rem;\n  margin: 0 auto;\n  text-align: center;\n  word-wrap: break-word;\n  white-space: normal;\n  color: #fecb00;\n}\n\n.medboldwhite{\n  font-family: 'Russo';\n  letter-spacing: 0.5px;\n  transition: padding 0.2s ease;\n  color: #ffffff; /* or #fecb00 for yellow */\n  font-size: 1.5rem;\n  margin: 0 auto;\n  text-align: center;\n  word-wrap: break-word;\n  white-space: normal;\n  color: #ffffff;\n}\n\n.bignormaltext{\n  font-family: 'Roboto';\n  transition: padding 0.2s ease;\n  color: #ffffff;\n  font-size: 24px;\n}\n\n.bigboldyellow,\n.bigboldwhite {\n  font-size: 3rem; /* Default for desktop */\n}\n\n@media screen and (max-width: 768px) {\n  .bigboldyellow,\n  .bigboldwhite {\n    font-size: 2rem; /* Smaller font size for mobile */\n  }\n}\n\n\n.normalText {\n  letter-spacing: 1px;\n  color: #ffffff;\n  font-family: 'Roboto';\n\n}\n\n\nbody {\n    /* width: 100vh;\n    height: 100vh; */\n    /* background: #cce8ff; */\n    animation: gradient 15s ease infinite;\n    word-wrap: break-word;\n  white-space: normal;\n  text-align: center;\n  background-color: #008cff;\n}\na {\n  text-decoration: none;\n}\n@font-face {\n  font-family: 'Russo';\n  src: url('Russo.ttf') format('truetype');\n  /* Add other font properties if needed, like font-weight and font-style */\n}\n/* \n@keyframes gradient {\n    0% {\n      background-color: #ee5252f2;\n    }\n    50% {\n      background-color: #23a6d5;\n    }  \n    100% {\n        background-color: #ee5252f2;\n    }\n} */\n\n.box{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\nh1 {\n    text-align: center;\n}\n\n#myCarousel{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sidebar {\n    background-color: #f0f0f0;\n    width: 200px;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    padding: 20px;\n  }\n  \n  .content {\n    margin-left: 200px;\n    padding: 20px;\n  }\n\n  /* The side navigation menu */\n.sidenav {\n  height: 100%; /* 100% Full-height */\n  width: 0; /* 0 width - change this with JavaScript */\n  position: fixed; /* Stay in place */\n  z-index: 1; /* Stay on top */\n  top: 0; /* Stay at the top */\n  left: 0;\n  background-color: #111; /* Black*/\n  overflow-x: hidden; /* Disable horizontal scroll */\n  padding-top: 60px; /* Place content 60px from the top */\n  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */\n}\n\n/* The navigation menu links */\n.sidenav a {\n  padding: 8px 8px 8px 32px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #818181;\n  display: block;\n  transition: 0.3s;\n}\n\n/* When you mouse over the navigation links, change their color */\n.sidenav a:hover {\n  color: #f1f1f1;\n}\n\n/* Position and style the close button (top right corner) */\n.sidenav .closebtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 36px;\n  margin-left: 50px;\n}\n\n/* Style page content - use this if you want to push the page content to the right when you open the side navigation */\n#main {\n  transition: margin-left .5s;\n  padding: 20px;\n}\n\n/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */\n@media screen and (max-height: 450px) {\n  .sidenav {padding-top: 15px;}\n  .sidenav a {font-size: 18px;}\n}\n\na{\n  color: white;\n}\n\n.sidebar-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Set the container height to 100% of the viewport height */\n  background: black;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\nul {\n  flex-grow: 1; /* Make the UL element fill the remaining height */\n  /* Add any other styles for your UL element */\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.col-9-full-width {\n  width: 100%;\n}\n\n.col-9{\n  width: 75%;\n}\n\n.images{\n  padding: 20px;\n  border-radius: 30px ;\n}\n\n\nbutton{\n  border-radius: 80px !important;\n  border: double 2px #ffffff;\n  background-image: linear-gradient(#fecb00, #fecb00);\n  /* background-clip: padding-box, border-box; */\n  cursor: pointer;\n  padding: 10px 15px; /* Initial padding */\n  align-items: center;\n  justify-content: center;\n  color: #005293;\n  transition: padding 0.2s ease; /* Smooth transition for padding */\n  font-weight: 900;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */\n  text-shadow: 0px 0px 0px #008cff;\n  font-size: 24px;\n}\n\nbutton:hover {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */\n  background-image: linear-gradient(#005293, #005293);\n  color: #fecb00;\n  border: double 2px #fecb00 ;\n  /* border: 5px solid var(--accent-color); */\n}\n\n.nonScrollable {\n  height: 100vh; /* Set the height to 100% of the viewport height */\n  overflow: hidden; /* Hide any content that exceeds the container height */\n  /* background-color: blue; */\n  flex-shrink: 0;\n}\n\n.scrollable {\n  height: 100vh; /* Set the height to 100% of the viewport height */\n  overflow-y: scroll; /* Add a vertical scrollbar when content exceeds the container height */\n  /* background-color: #cce8ff; */\n  background-color: #193551;\n}\n\n.scrollableContent {\n  /* height: 100%; Ensure the scrollable content takes up the full height of the container */\n  /* display: flex; */\n/* justify-content: center;\nalign-items: center; */\n}\n\n/* When the sidebar collapses */\n.sidebar-collapsed body {\n  /* Adjust the scrollbar width to 100% */\n  scrollbar-width: auto;  /* For Firefox */\n  scrollbar-color: initial;  /* For Chrome, Edge, and Safari */\n}\n\n.showSidebar{\n  display: block;\n}\n\n.hideSidebar{\n  display: none;\n} \n\n.tier-list {\n  display: flex;\n  justify-content: space-around;\n  gap: 20px;\n}\n\n.tier {\n  border: 1px solid #ccc;\n  padding: 20px;\n  max-width: 300px;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .row {\n    flex-direction: row; /* Ensure it remains a row */\n  }\n\n  .col-auto {\n    flex: 0 0 auto; /* Prevent columns from stretching */\n  }\n\n  .col {\n    flex: 1; /* Allow this column to fill remaining space */\n  }\n\n  \n\n  button {\n    margin: 0; /* Ensure proper alignment for the button */\n    padding: 25px 35px; /* Initial padding */\n  }\n}\n.contained {\n  background: #66baff;\n  padding: 10px 15px; /* Adjust padding to control spacing */\n  margin: 10px;\n  border: 3px solid black;\n  border-radius: 20px;\n  text-align: center; /* Centers text */\n  box-sizing: border-box; /* Ensures padding is included in the dimensions */\n}\n\n.contained p {\n  margin: 0; /* Removes default margin on the <p> tag */\n  line-height: 1.5; /* Adjust line height for better spacing */\n}\n\n@media (max-width: 650px) {\n  .contained {\n    background-color: #b3ddff;\n    border-radius: 10px;\n    padding: 10px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
